import BtnFavorite from './BtnFavorite'

export default BtnFavorite
